// src/Components/FooterSection/index.jsx
import logo from '../../Assets/logo_footer.png'
import { FaInstagram, FaYoutube, FaFacebook } from "react-icons/fa";
import file from '../../Documents/file.pdf'
import * as S from "./styles";

export const FooterSection = () => {
  return (
    <S.Wrapper>
      <S.TopMobile>
        <S.Socials size="lg">
          <a
            href="https://www.facebook.com/bindflow.io/?locale=pt_BR"
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook size={40} />
          </a>

          <a
            href="https://www.youtube.com/channel/UCqE59qW4cFd7A7b5gGPbSvA"
            aria-label="YouTube"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube size={40} />
          </a>

          <a href="https://www.instagram.com/bindflow.io/"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={40} />
          </a>
        </S.Socials>

        <img src={logo} alt="" />
      </S.TopMobile>

      <S.GridDesk>
        <S.Col>
          <img src={logo} alt="" />

          <p>contato@bindflow.com.br</p>
          <p>+55 41 98454-9244  </p>

          <p>R. Comendador Roseira, 352<br />
            Curitiba, PR<br />
            80215-210
          </p>
        </S.Col>

        <S.Col>
          <S.NavRow>
            <a href="/">Home</a>
            <a href="/solucoes">Soluções
              <S.SubLinks>
                <a href="/solucoes/bindinntech">Bindinntech</a>
                <a href="/solucoes/bindtrack">Bindtrack</a>
                <a href="/solucoes/fisioteraplay">Fisioteraplay</a>
                <a href="/solucoes/atendevet">Atendevet</a>
                <a href="/solucoes/whatsign">Whatsign</a>
              </S.SubLinks>
            </a>
            <a href="/cases">Cases</a>
            <a href="/quem-somos">Quem Somos</a>
            <a href="/solucoes">Política da Empresa
              <S.SubLinks>
                <a
                  href={file}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >Código de Conduta e Ética</a>
                <a href="/canalDenuncia">Canal de Denúncias</a>
              </S.SubLinks>
            </a>
            <a href="/contato">Contato</a>
          </S.NavRow>
        </S.Col>

        <S.Col align="right">
          <S.Socials
            style={{
              gap: '16px'
            }}>

            <a
              href="https://www.facebook.com/bindflow.io/?locale=pt_BR"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={32} />
            </a>

            <a
              href="https://www.youtube.com/channel/UCqE59qW4cFd7A7b5gGPbSvA"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube size={32} />
            </a>

            <a href="https://www.instagram.com/bindflow.io/"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={32} />
            </a>
          </S.Socials>
        </S.Col>
      </S.GridDesk>

      <S.Copybar>
        2023 Bindflow. Todos os direitos reservados. · CNPJ: 43.103.064/0001-78 · Rua Imac. Conceição, 1430
      </S.Copybar>
    </S.Wrapper >
  );
};
